export const BLOCK_USER_TOAST_GROUP = 'block-status';
export const DISCONNECTED_USER_TOAST_GROUP = 'disconnected-user';
export const INVITE_TO_STAGE_TOAST_GROUP = 'invite-to-stage';

export const TOAST_VERSION_2 = '2.0';
export const TOAST_DURATION_LONG = 200000000000000;
